import axios from "axios";
import { banner, webView } from "../../variables/webView";
import GetQrLink from "./getQrLink";
export { GetQrLink };
let token = window.token;

export const QrFile = async (data) => {
  const formData = new FormData();
  formData.append("type", 47);
  formData.append("file", data[0]);
  !!token && formData.append("token", token);
  !!data[1] && formData.append("advertisingIabCategories[]", [data[1]]);
  !!data[2] && formData.append("qrTitle", data[2]);

  const response = await axios({
    url: webView ? `/file/ajax/new${banner}` : "/file/ajax/new",
    method: "POST",
    data: formData,
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const QrFileEdit = async (data) => {
  const formData = new FormData();
  formData.append("type", 47);
  formData.append("file", data[1]);
  !!token && formData.append("token", token);
  !!data[2] && formData.append("advertisingIabCategories[]", [data[2]]);
  !!data[3] && formData.append("qrTitle", data[3]);

  const response = await axios({
    url: `/file/ajax/edit/${data[0]}`,
    method: "POST",
    data: formData,
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};
